import { PricingTierApi } from "@/api";
import i18n from "@/i18n";
import { showSuccessSnackbar } from "@/utilities/snackbar";

export async function getAll() {
  const { data } = await PricingTierApi.getAll();
  return data;
}

export async function create(data) {
  const { status } = await PricingTierApi.create(data);
  showSuccessSnackbar(status, `${i18n.t("pricing-tier-created-success")}`);
}

export async function update(id, data) {
  const { data: response } = await PricingTierApi.update(id, data);
  showSuccessSnackbar(200, `${i18n.t("pricing-tier-updated-success")}`);
  return response;
}

export async function remove(id) {
  const { status } = await PricingTierApi.remove(id);
  showSuccessSnackbar(status, `${i18n.t("pricing-tier-deleted-success")}`);
}
